import { render } from "./textbook-phone.vue?vue&type=template&id=5bc4cc5a&scoped=true"
import script from "./textbook-phone.vue?vue&type=script&lang=js"
export * from "./textbook-phone.vue?vue&type=script&lang=js"

import "./textbook-phone.vue?vue&type=style&index=0&id=5bc4cc5a&scoped=true&lang=scss"
import "./textbook-phone.vue?vue&type=style&index=1&id=5bc4cc5a&lang=css"

import exportComponent from "E:\\my-work\\company\\product\\LessonPlay\\lessonplay_shell\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bc4cc5a"]])

export default __exports__